import React from "react";
import { useGlobalState } from "../context/Global";

function ProgressBar() {
  const { tasksTotal, tasksChecked } = useGlobalState();
  const tasksProgress = tasksTotal() > 0 ? (tasksChecked() / tasksTotal()) * 100 : 0;

  return (
    <div className="bg-gray-100 text-center py-4 pb-6 relative font-bold text-lg text-black">
      {tasksTotal() > 0 ? (
        <div>
          You completed <span className="text-secondary-dark text-2xl">{tasksChecked()}</span> out of your <span className="text-secondary-dark text-2xl">{tasksTotal()}</span> tasks
        </div>
      ) : (
        <div>
          Please select a role…<span className="text-2xl">&nbsp;</span>
        </div>
      )}
      <div className="bg-secondary-light absolute w-full h-3 bottom-0" />
      <div className="bg-secondary-dark absolute h-3 bottom-0 transition-all duration-300" style={{ width: tasksProgress + "%" }} />
    </div>
  );
}

export default ProgressBar;
